
// Function to clean and strip text of any formatting
export const cleanText = (text) => {
    // Remove HTML tags
    let cleanedText = text.replace(/<\/?[^>]+(>|$)/g, "");
    // Remove Markdown formatting
    cleanedText = cleanedText.replace(/(\*\*|__|~~|`|>|\[|\]|\(|\)|!|\*|#|\+|-|_|=|~|`|>|<)/g, "");
    // Remove extra whitespace
    cleanedText = cleanedText.replace(/\s\s+/g, ' ').trim();
    return cleanedText;
};
